export default __webpack_public_path__ + "static/media/bgMain_desktop.a177be76.svg";